/* eslint-disable
    no-unused-vars
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import _ from 'underscore';

import SequenceSearchViewTemplate from 'components/SequenceSearchViewTemplate';
import SearchResultRowTemplate from 'components/SearchResultRowTemplate';
import SequenceSearchMessageRowTemplate from 'components/SequenceSearchMessageRowTemplate';
import * as keyboard from 'util/Keyboard';
import {debounce} from 'ts-debounce';
import {NucleotideType} from 'biojs/BioConstants';

export class SequenceSearchResult extends Backbone.Model {
  folder() {
    return this.get('folder');
  }

  permissions() {
    return this.get('permissions');
  }
}

class SequenceSearchResults extends Backbone.Collection {
  url = '/1/api/all/search?filter=long_sequence';

  static initClass() {
    this.prototype.model = SequenceSearchResult;
  }

  parse(response) {
    // TODO(T1750): Callers expect `writable` key.
    // eslint-disable-next-line no-restricted-syntax
    return response.data.map((result) => _.extend({writable: result.permissions.writable}, result));
  }
}
SequenceSearchResults.initClass();

class DnaSequenceSearchResults extends SequenceSearchResults {
  url = '/1/api/all/search?filter=sequence';
}
DnaSequenceSearchResults.initClass();

class RnaSequenceSearchResults extends SequenceSearchResults {
  url = '/1/api/all/search?filter=rna_sequence';
}
RnaSequenceSearchResults.initClass();

class RnaSequenceWithoutModsSearchResults extends SequenceSearchResults {
  url = '/1/api/all/search?filter=rna_sequence_no_mods';
}
RnaSequenceWithoutModsSearchResults.initClass();

class SequenceSearchView extends Backbone.View {
  static initClass() {
    this.prototype.template = SequenceSearchViewTemplate;
    this.prototype.resultRowTemplate = SearchResultRowTemplate;
    this.prototype.messageRowTemplate = SequenceSearchMessageRowTemplate;

    this.prototype.events = {
      'input .search-input': 'handleSearchInput',
      'click .search-results a.list-group-item': 'selectResultOnClick',
      'keydown .search-input': 'selectResultOnEnter',
      'keyup .search-input': 'escapeSearch',
    };

    this.prototype.performSearch = debounce(function (query) {
      if (this._inflightXHRs != null) {
        this._inflightXHRs.forEach((xhr) => xhr.abort());
      }
      if (query.length > 0) {
        this._inflightXHRs = this.fetchResults(query);
        $.when(...Array.from(this._inflightXHRs || [])).done(() => this.updateSearchResults());
      } else {
        this.hideSpinner();
        this.clearSearch();
        this._inflightXHRs = null;
      }
    }, 250);
  }

  initialize(options) {
    _.defaults(options, {
      clearSearchAfterClick: true,
      alwaysDisplayResults: false,
    });

    ({
      selectSequence: this.selectSequence,
      clearSearchAfterClick: this.clearSearchAfterClick,
      alwaysDisplayResults: this.alwaysDisplayResults,
    } = options);
    if (!options.nucleotideType) {
      this.sequenceResults = new SequenceSearchResults();
    } else if (options.nucleotideType === NucleotideType.DNA) {
      this.sequenceResults = new DnaSequenceSearchResults();
    } else if (options.nucleotideType === NucleotideType.RNA && options.excludeModified) {
      this.sequenceResults = new RnaSequenceWithoutModsSearchResults();
    } else if (options.nucleotideType === NucleotideType.RNA) {
      this.sequenceResults = new RnaSequenceSearchResults();
    }
    this._inflightXHRs = null;
  }

  showSpinner() {
    this.$('.sequence-search-wrapper .spinner').removeClass('hidden');
  }

  hideSpinner() {
    this.$('.sequence-search-wrapper .spinner').addClass('hidden');
  }

  showNoResultsMessage() {
    const query = this.$('.search-input').val();
    const $els = [
      $(
        this.messageRowTemplate({
          message: 'No matches found',
        })
      ),
    ];
    this.$('.search-results').empty().append($els);
    this.$('.search-results').show();
  }

  updateSearchResults() {
    this.hideSpinner();
    if (this.sequenceResults.length === 0) {
      this.showNoResultsMessage();
      return;
    }
    const $els = this.sequenceResults.map((sequence) =>
      $(
        this.resultRowTemplate({
          searchLibrary: false,
          name: sequence.get('name'),
          path: this._getSequencePath(sequence),
        })
      ).data('result', sequence)
    );
    this.$('.search-results').empty().append($els);
    this.$('.search-results').show();
  }

  _getSequencePath(sequence) {
    return `${sequence.get('owner')}/${sequence.folder().name}`;
  }

  handleSearchInput(e) {
    this.showSpinner();
    this.performSearch($(e.target).val());
  }

  fetchResults(query) {
    return [this.sequenceResults.fetch({data: {q: query}})];
  }

  displaySearchResults(e) {
    // Show search result if mousedown inside search wrapper.
    this.$('.search-results').toggle(this.$(e.target).length > 0);
  }

  focus() {
    this.$('.search-input').focus();
  }

  setInputValue(val) {
    this.$('.search-input').val(val);
  }

  clearSearch() {
    this.$('.search-input').val('');
    this.$('.search-results').empty();

    if (this.alwaysDisplayResults) {
      this.showNoResultsMessage();
    }
  }

  selectResult($target) {
    const sequence = $target.data('result');
    if (this.clearSearchAfterClick) {
      this.clearSearch();
    }
    this.selectSequence(sequence);
  }

  selectResultOnClick(e) {
    const $target = $(e.currentTarget);
    this.selectResult($target);
  }

  selectResultOnEnter(e) {
    if (e.which !== 13) {
      return;
    }
    e.preventDefault();
    const $item = this.$('.search-results a.list-group-item').first();
    if ($item.length === 0) {
      return;
    }
    this.selectResult($item);
  }

  escapeSearch(e) {
    if (keyboard.isEscapeKey(e) && this.$('.search-input').val()) {
      // If this search view is embedded in a modal, prevent the modal from closing
      e.stopPropagation();
      this.clearSearch();
    }
  }

  render() {
    this.$el.html(this.template({searchLibrary: false}));
    if (this.alwaysDisplayResults) {
      this.showNoResultsMessage();
    }
    return this;
  }
}
SequenceSearchView.initClass();

export default SequenceSearchView;
